import { KnmCollapse } from '../../KnmPackage/MainModule/components/KnmCollapse';
import { IGroupObjectConditionsForm } from '../PassportGroupFormModule/interfaces/IGroupObjectConditionsForm';
import { FieldBlock } from '../../UIPackage/FormModule/components/FieldBlock';
import { SelectInput } from '../../UIPackage/MainModule/components/SelectInput';

interface IPassportGroupDetailObjectConditionsProps {
  condition: IGroupObjectConditionsForm | undefined;
}

export const PassportGroupDetailObjectConditions = ({ condition }: IPassportGroupDetailObjectConditionsProps) => {
  if (!condition || !Object.values(condition).find(item => !!item)) {
    return null;
  }

  return (
    <KnmCollapse title="Сведения об объектах контроля мероприятий">
      <>
        {!!condition.ervkNumbers?.length && (
          <FieldBlock label="Категорированный объект контроля ЕРВК" margin="bottom">
            <SelectInput value={condition.ervkNumbers} isMulti disabled />
          </FieldBlock>
        )}
        {!!condition.objectTypes?.length && (
          <FieldBlock label="Тип объекта контроля" margin="bottom">
            <SelectInput value={condition.objectTypes} isMulti disabled />
          </FieldBlock>
        )}
        {!!condition.objectKinds?.length && (
          <FieldBlock label="Вид объекта контроля" margin="bottom">
            <SelectInput value={condition.objectKinds} isMulti disabled />
          </FieldBlock>
        )}
        {!!condition.objectSubKinds?.length && (
          <FieldBlock label="Подвид объекта контроля" margin="bottom">
            <SelectInput value={condition.objectSubKinds} isMulti disabled />
          </FieldBlock>
        )}
        {!!condition.riskCategories?.length && (
          <FieldBlock label="Категория риска объекта контроля" margin="bottom">
            <SelectInput value={condition.riskCategories} isMulti disabled />
          </FieldBlock>
        )}
        {!!condition.dangerClasses?.length && (
          <FieldBlock label="Класс опасности объекта контроля" margin="bottom">
            <SelectInput value={condition.dangerClasses} isMulti disabled />
          </FieldBlock>
        )}
      </>
    </KnmCollapse>
  );
};
